export const LESSON_STATE_PUBLISHED = "published"
export const LESSON_STATE_DRAFT = "draft"

export const lessonStateOptions = {
  [LESSON_STATE_PUBLISHED]: "Опубликована",
  [LESSON_STATE_DRAFT]: "Черновик",
}
